import React, {Component} from 'react';
import {getUserClients} from "../services/UsersService";
import {Alert, Avatar, Button, Card, Divider, Icon, List} from "antd";
import {getAvatarColor} from "../services/APIService";
import {SECURITY_ROLE_OWNER} from "../constants/constants";
import google_play_badge from "../resources/google-play-badge.png"
import apple_store_badge from "../resources/apple-store-badge.png"
import {Link} from "react-router-dom";

class ClientAccess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        this.loadUserClients()
    }

    loadUserClients() {
        this.setState({
            clients: getUserClients()
        })
    }

    render() {
        const clients = [];
        if (this.state.clients) {
            Object.keys(this.state.clients).forEach((key, index) => {
                clients.push(this.state.clients[key])
            });
        }

        return (
            <div>
                <Alert
                    message="Importante"
                    description={
                        <div>
                            Para acceder a la funcionalidades de cada punto de control de acceso, su administrador ha restringido la ejecución mediante la aplicación móvil disponible en:
                            <br/>
                            <a href="https://play.google.com/store/apps/details?id=com.hodoor.hodoor_ui">
                                <img alt="" height="65" src={google_play_badge}/>
                            </a>
                            <a href="https://apps.apple.com/us/app/hodoor/id6449297094" className="mrg-left">
                                <img alt="" height="45" src={apple_store_badge}/>
                            </a>
                        </div>
                    }
                    type="info"
                    showIcon
                />
                <div className="action-separator"></div>
                <Divider>Mis espacios</Divider>
                <List itemLayout="horizontal"
                      grid={{gutter: 16, xs: 1, lg: 2}}
                      dataSource={clients}
                      renderItem={item => (
                          <List.Item key={item.id}>
                              <Card>
                                  <Card.Meta title={
                                      <div>{item.name} {item.role === SECURITY_ROLE_OWNER ? <Link className="float-right" to={"/management/" + item.id}><Button type="primary" shape="circle"><Icon type="setting"/></Button></Link> : null}</div>
                                  } avatar={
                                      <Avatar className="client-avatar-circle"
                                              style={{backgroundColor: getAvatarColor(item.name)}}>
                                          {item.name[0].toUpperCase()}
                                      </Avatar>
                                  } description={
                                      <div>
                                          {item.address}
                                          <Divider/>
                                          <div>{'Nivel de permisos: ' + (item.role === SECURITY_ROLE_OWNER ? 'administrador' : 'usuario')}</div>
                                          {
                                              item.role === SECURITY_ROLE_OWNER ?
                                                  <sub>Todos los privilegios, administración y acceso total</sub>
                                                  :
                                                  <sub>Accesso total</sub>
                                          }
                                      </div>
                                  }>
                                  </Card.Meta>
                              </Card>
                          </List.Item>
                      )}
                />
            </div>
        );
    }
}

export default ClientAccess;


// WEBPACK FOOTER //
// ./src/app/views/ClientAccess.js